import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
import DataTable from 'react-data-table-component';
import {MdDeleteOutline,MdOutlineEdit} from "react-icons/md"
import {AiOutlineEye} from "react-icons/ai"
const ModuleScreenList = () => {
    let navigate = useNavigate();

    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get("/account/modulescreen/")
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        GetData();
    }, [])

    const columns = [
        {
            name: "Id",
            selector: row => row.id,
            sortable: true
        },
        {
            name: "Screen Code",
            selector: row => row.screen_code,
            sortable: true
        },
        {
            name: "Module Screen Name",
            selector: row => row.screen_name,
            sortable: true
        },
        {
            name: "Module Screen Description",
            selector: row => row.screen_description,
            sortable: true
        },
        {
            name: "Icon Name",
            selector: row => row.icon_name,
            sortable: true
        },
        {
            name: "Order Number",
            selector: row => row.order_number,
            sortable: true
        },
         {
            name: "ACTIONS",
            selector: row => {
                const HandleEdit = async() => {
                    return navigate(`/dashboard/masters/modulescreen/${row.id}/edit`);
                }
                const HandleDelete = async() => {
                    await axiosConfig.delete(`/account/modulescreen/${row.id}/`).then(()=>{
                        GetData()
                    }).catch((error)=> {
                        console.log(error)
                    })
                }
                return (
                    <>
                         <div className="row" >
                            <div className="col-4">
                            <AiOutlineEye className="dashboard-tabe-data-actions"  onClick={HandleEdit}/>
                            </div>
                            <div className="col-4">
                                <MdOutlineEdit className="dashboard-tabe-data-actions"  onClick={HandleEdit}/>
                            </div>
                            <div className="col-4">
                                <MdDeleteOutline className="dashboard-tabe-data-actions" onClick={HandleEdit}/>
                            </div>
                        </div>
                    </>
                )

            }
        }
    ]
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">View Module Screen</h5>
                    <NavLink to="/dashboard/masters/modulescreen/add" ><button className="btn btn-white">Add New</button></NavLink>
                </div>
                <div>
                <DataTable columns={columns} data={Data} pagination fixedHeader />
                </div>
                
            </DashboardLayout>
        </>
    )
}
export { ModuleScreenList }